import Tooltip from './Tooltip';

export { default as Title } from './TooltipTitle';
export { default as Trigger } from './TooltipTrigger';
export { default as Wrapper } from './TooltipWrapper';

export default Tooltip;
